import styled from "styled-components";
import { labelColor } from "@app/styles";

type Props = {
  disabled?: boolean;
};

export const ButtonContainer = styled.div`
  display: flex;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          cursor: not-allowed;
          button{
            background-color:rgb(236 236 236 / 50%);
            pointer-events:none;
            color:${labelColor};
          }
      `;
    }
  }}
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 25px 0px;
`;

export const StudentType = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  label {
    margin: 5px 0 0 8px;
  }
`;
